import { useState, useEffect } from 'react'
import { ButtonFilledAutoWidth, ButtonOutlinedAutoWidth } from '../../components/button'
import { DatePicker, Modal, Select } from 'antd';
import { useNavigate } from 'react-router-dom';
import { FiChevronRight, FiChevronLeft } from 'react-icons/fi';
import { IconButton } from '@material-ui/core';
import { AiOutlineEdit,AiOutlineDelete } from 'react-icons/ai';
import { BiCheckbox, BiCheckboxSquare } from 'react-icons/bi';
import toast from 'react-hot-toast';
import moment from 'moment';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import { DeleteClientService, GetOfflineClientService, UpdateClientActiveStatusService } from '../../services/ClientServices';
import { GetCityListService } from '../../services/admin/CityListServices';
import SettingsMenu from '../staticscreens/SettingsMenu';
import { CiViewTable } from "react-icons/ci";
import OfflineCustomerMenu from './OfflineCustomerMenu';

function OfflineCustomerList() {

  const navigator = useNavigate()
  const roles = useSelector(state=>state.Auth.roles)



  const [modal, setmodal] = useState(false)
  const [page, setpage] = useState(1)
  const [data, setdata] = useState({})
  const [selecteddata, setselecteddata] = useState({})

  const [step, setstep] = useState("Manually Added")
  let stages = ['Manually Added','Added From Website','Converted','Not Converted','Fees Ended','Fees Paid','Today Present','Today Absent','3 Days Absent','Active','Inactive','All Data','Global Data']
  const ATTENDANCE_STEPS = ['Today Present', 'Today Absent', '3 Days Absent']

  // Controlled DatePicker value for the 3 attendance tabs — antd v5's picker
  // needs a dayjs instance here (not moment), same fix as the teacher
  // feedback month picker. Defaults to today on first load.
  const [attendanceDate, setattendanceDate] = useState(dayjs())

  const [search, setsearch] = useState({ text: '',text1: '', from_date: '', to_date: '', from_date1: '', to_date1: '', activate: false })

  const [cityOptions, setcityOptions] = useState([])
  const [city, setcity] = useState('')

  useEffect(()=>{
    async function loadCities(){
      const response = await GetCityListService()
      const cities = (response?.data?.datas?.[0]?.datas || '').split(',').map((c)=>c.trim()).filter(Boolean)
      setcityOptions(cities?.map((c)=>({label:c,value:c})))
    }
    loadCities()
  },[])

  useEffect(() => {
    getdata()
  }, [page,step,attendanceDate,city])

  async function getdata() {
    const response = await GetOfflineClientService(page,search?.text,search?.from_date1,search?.to_date1,step,'',attendanceDate?.format('YYYY-MM-DD'),city || '');
    setdata(response?.data)
  }


  async function applyFilter() {
    setsearch({ ...search, activate: true })
    setpage(1)
    const response = await GetOfflineClientService(1,search?.text,search?.from_date1,search?.to_date1,step,'',attendanceDate?.format('YYYY-MM-DD'),city || '')
    setdata(response?.data)
  }

  async function resetfilter() {
    setsearch({ text: '', from_date: '', to_date: '', from_date1: '', to_date1: '', activate: false,text1:'',teacher:'' })
    setcity('')
    setpage(1)
    const response = await GetOfflineClientService(1,'','','',step,'',attendanceDate?.format('YYYY-MM-DD'),'')
    setdata(response?.data)
  }


  async function toggleActive(d) {
    const nextActive = d?.is_active === false
    const response = await UpdateClientActiveStatusService({ is_active: nextActive }, d?._id)
    if (response?.status === 200) {
      toast.success(nextActive ? 'Marked as active' : 'Marked as inactive')
      getdata()
    } else {
      toast.error(response?.data?.errors || 'Something went wrong')
    }
  }

  async function deleteData() {
    const response = await DeleteClientService(selecteddata?._id)
    if (response?.status === 200) {
      toast.success("Deleted Successfully")
    } else {
      toast.success("Deleted Successfully")
    }
    setmodal(false)
    getdata()
  }

 
  return (
    <div className='w-[98%] md:h-screen md:overflow-hidden'>

      <Modal
        keepMounted
        open={modal}
        onClose={() => setmodal(false)}
        width={300}
        footer={false}
        closable={false}

      >
        <div >
          <h6 className="font-bold text-[15px] text-center mb-2 w-full">Are you sure?</h6>
          <h6 className='bg-slate-100 text-center text-[12px] p-1.5 font-[400]'>After deleting you cannot retrieve it back before deleting check once whether you have used it in some data</h6>
          <div className='flex justify-end mt-3 '>
            <ButtonOutlinedAutoWidth btnName={'Cancel'} onClick={() => setmodal(false)} />
            <div className='ml-2'>
              <ButtonFilledAutoWidth btnName={'Confirm'} onClick={() => deleteData()} />
            </div>
          </div>
        </div>
      </Modal>

      <div className='md:flex'>
        <div>
          <OfflineCustomerMenu />
        </div>
        <div className='md:w-[90%] pl-5 mt-4'>

          <div className='md:flex items-center -mt-1 border-b justify-between pb-1'>
            <div className='flex items-center justify-between'>
            <h6 className='font-[800] text-[13px]'>Total Offline Students ({data?.pagination?.total})</h6>
            <div className='flex md:hidden items-center text-[12px]'>
              {/* <AiOutlineFileExcel onClick={() => downloaddata()} size={24} className='mx-2 bg-gray-200 p-1.5' /> */}

              <h6 className='mr-2 font-[600]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit} - {data?.pagination?.limit} of {data?.pagination?.total}  </h6>

              <div>
                <IconButton onClick={() => { page > 1 ? setpage(page - 1) : console.log('') }}><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`} size={16} /></IconButton>
                <IconButton onClick={() => { page < data?.pagination?.totalPages ? setpage(page + 1) : console.log('') }}><FiChevronRight className={`${(data?.pagination?.totalPages === page || data?.datas?.length === 0) ? 'opacity-50 ' : 'opacity-100'}`} size={16} /></IconButton>
              </div>
            </div>
            </div>

            <div className='flex flex-wrap items-center text-[12px]'>

              <div className='hidden md:flex items-center'>
              {/* <AiOutlineFileExcel onClick={() => downloaddata()} size={24} className='mx-2 bg-gray-200 p-1.5' /> */}

              <h6 className='mr-2 font-[600]'>{page == 1 ? data?.datas?.length > 0 ? 1 : 0 : (page - 1) * data?.pagination?.limit} - {data?.pagination?.limit} of {data?.pagination?.total}  </h6>

              <div>
                <IconButton onClick={() => { page > 1 ? setpage(page - 1) : console.log('') }}><FiChevronLeft className={`${page === 1 ? 'opacity-50' : 'opacity-100'}`} size={16} /></IconButton>
                <IconButton onClick={() => { page < data?.pagination?.totalPages ? setpage(page + 1) : console.log('') }}><FiChevronRight className={`${(data?.pagination?.totalPages === page || data?.datas?.length === 0) ? 'opacity-50 ' : 'opacity-100'}`} size={16} /></IconButton>
              </div>
              </div>

              <div className='mr-2 flex items-center mt-1 md:mt-0'>

                <input id="search_text" placeholder='Search text' type='text' value={search.text} onChange={(e) => setsearch({ ...search, text: e.target.value })} className='border py-[3px] mr-2 focus:ring-0 focus:outline-0 text-[12px]  w-[100px] px-1 rounded-md border-slate-300' />

                <DatePicker size='small' style={{ fontSize: '11px' }} ampm={false} placeholder='From Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2' value={search?.from_date} onChange={(v, v1) => { console.log('v na', new Date(v).toLocaleDateString()); setsearch({ ...search, from_date: v, from_date1: v1 }) }} />

                <DatePicker size='small' style={{ fontSize: '11px' }} ampm={false} placeholder='To Date' className='text-[11px] py-[2.6px]  w-28 border-slate-300 mr-2' value={search?.to_date} onChange={(v, v1) => { console.log('v na', new Date(v).toLocaleDateString()); setsearch({ ...search, to_date: v, to_date1: v1 }) }} />

                <div className='mr-2 w-[130px]'>
                  <Select
                    showSearch
                    allowClear
                    filterOption={(input,option)=>(option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                    value={city === '' ? null : city}
                    bordered={false}
                    onChange={(v)=>{setcity(v || '');setpage(1)}}
                    className='border rounded h-[29px] border-slate-300 w-[100%]'
                    options={cityOptions}
                    placeholder={<span className="text-[12px] text-gray-300">Select City</span>}
                    />
                </div>

              </div>
              <div className='mr-2 mt-1 md:mt-0'>
                <ButtonOutlinedAutoWidth btnName="Apply Filter" onClick={() => applyFilter()} />
              </div>
              <div className='mr-2 mt-1 md:mt-0'>
                <ButtonOutlinedAutoWidth btnName="Reset Filter" onClick={() => resetfilter()} />
              </div>

              <div className='mr-2 mt-1 md:mt-0'>
                <ButtonFilledAutoWidth btnName="Add New" onClick={() => navigator('create')} />
              </div>
            </div>
          </div>

          <div className='flex items-center border-b overflow-x-auto flex-nowrap'>
                {stages?.map((s)=>(
                <h6 key={s} onClick={()=>{setstep(s);setpage(1)}} className={`font-[600] ${step === s && 'bg-[#2a297e] text-white'} flex-shrink-0 text-center cursor-pointer py-1 w-auto px-2 text-[11px]`}>{s}</h6>
                ))}
            </div>

            {ATTENDANCE_STEPS.includes(step) && (
              <div className='flex items-center text-[12px] mt-2'>
                <span className='mr-2 font-[600] text-slate-500'>Attendance date:</span>
                <DatePicker
                  size='small'
                  allowClear={false}
                  style={{ fontSize: '11px' }}
                  className='text-[11px] py-[2.6px] w-32 border-slate-300'
                  value={attendanceDate}
                  onChange={(v) => { setattendanceDate(v || dayjs()); setpage(1) }}
                />
              </div>
            )}

          <div className='md:h-[90vh] mb-[50px] md:overflow-hidden'>

            {data?.datas?.length === 0 &&
              <div className='grid place-items-center mt-20  items-center justify-center'>
                <img src={'https://fidecrmfiles.s3.amazonaws.com/NoDataFound1.png'} className='w-40 h-40 object-contain' />
                <h6 className='font-bold text-[14px] -mt-10'>No data found</h6>
                <h6 className='font-[500] w-[70%] text-center text-slate-700 text-[12.5px] -mt-2'>Oops we couldn't find any data based on your current stage please add the data to see list here.</h6>
              </div>}

            <div className='w-[100%] overflow-hidden'>
              {data?.datas?.length > 0 &&
                <>
                {/* Desktop / tablet table */}
                <div className='hidden md:block md:max-h-[85vh] mt-4 md:overflow-auto border-t border-l border-r'>
                  <div className='sticky top-0 z-50 flex w-full  bg-white py-[-5px] border-b border-slate-200 relative'>
                    <h6 className='top-0 bg-white z-50 text-[12px] min-w-[50px] w-[50px]  px-2 py-1 font-[600] text-slate-800 border-r flex items-center justify-center'>Sl No</h6>
                    <h6 className='sticky top-0 z-50  text-[12px]  min-w-[160px] w-[160px]  px-2 py-1 font-[600] text-slate-800 border-r'>Student Name </h6>
                    <h6 className='sticky top-0 z-50  text-[12px]  min-w-[160px] w-[160px]  px-2 py-1 font-[600] text-slate-800 border-r'>Mobile</h6>
                    <h6 className='sticky top-0 z-50  text-[12px] min-w-[180px] w-[180px]  px-2 py-1 font-[600] text-slate-800 border-r'>Email</h6>
                    <h6 className='sticky top-0 z-50  text-[12px] min-w-[146px] w-[146px]  px-2 py-1 font-[600] text-slate-800 border-r'>Standard</h6>
                    <h6 className='sticky top-0 z-50  text-[12px] min-w-[200px] w-[200px]  px-2 py-1 font-[600] text-slate-800 border-r'>Class Info</h6>
                    <h6 className='sticky top-0 z-50  text-[12px] min-w-[120px] w-[120px]  px-2 py-1 font-[600] text-slate-800 border-r'>Created At</h6>
                    <h6 className='sticky top-0 z-50  text-[12px] min-w-[70px] w-[70px]  px-2 py-1 font-[600] text-slate-800 border-r'>Active</h6>
                    <h6 className='sticky top-0 z-50  text-[12px] min-w-[120px] w-[120px]  px-2 py-1 font-[600] text-slate-800'>Action</h6>
                  </div>
                  {data?.datas?.map((d, i) => (
                    <div key={d?._id || i} className='flex w-full text-[11px]  bg-white py-[-5px] border-b border-slate-200 relative'>
                      <h6 className='bg-white text-[12px] min-w-[50px] w-[50px]  px-2 py-1 font-[500] border-r flex items-start justify-center'>{(page > 1 ? i + 1 + (data?.pagination?.limit * (page - 1)) : i + 1)}</h6>

                      <h6 className=' text-[12px] break-word min-w-[160px] w-[160px] px-2 py-1 font-[500] border-r'>
                        <span className='font-bold'>{d?.name}</span><br></br>
                        {d?.mode_type && <h6 className={`${d?.mode_type === 'Online' ? 'bg-green-200' : 'bg-blue-200'}
                        p-[2px] m-[2px] text-[10px] font-[800] w-max rounded`}>{d?.mode_type}</h6>}

                        {d?.fees_end_date && <span className='text-[9px]'>Fees End Date : {moment(d?.fees_end_date)?.format('LL')}</span>}
                      </h6>
                      <h6 className=' text-[12px] break-all min-w-[160px] w-[160px]  px-2 py-1 font-[500] border-r'>
                       <h6 className='text-[11px]'>{d?.mobile}</h6>
                      </h6>
                      <h6 className=' text-[11px] break-all min-w-[180px] w-[180px]  px-2 py-1  border-r'>
                        {d?.email}
                      </h6>
                      <h6 className='flex break-word  min-w-[146px] w-[146px]  px-2 py-1 font-[500] border-r'>{d?.classInfo}</h6>
                      <h6 className='flex break-word  min-w-[200px] w-[200px]  px-2 py-1 break-all font-[500] border-r'>{d?.class_room?.name} [{d?.class_room?.label}]</h6>
                      <h6 className='  break-word min-w-[120px] w-[120px]  px-2 py-1 font-[500] border-r'>{moment(d?.createdAt)?.format('LL')}</h6>
                      <h6 className='min-w-[70px] w-[70px] px-2 py-1 border-r flex items-start justify-center cursor-pointer' onClick={() => toggleActive(d)}>
                        {d?.is_active !== false ? <BiCheckboxSquare size={20} className='text-slate-800' /> : <BiCheckbox size={20} className='text-slate-300' />}
                      </h6>
                      <h6 className='text-[12px] flex items-start min-w-[120px] w-[120px]  px-2 py-1 font-[600] text-slate-800'>
                        <AiOutlineEdit onClick={() => navigator('edit', { state: d })} className='mr-2' />
                        <AiOutlineDelete onClick={() => {setselecteddata(d);setmodal(true)}} className='mr-2' />
                      </h6>
                    </div>))}
                </div>

                {/* Mobile card list */}
                <div className='md:hidden mt-3 space-y-2'>
                  {data?.datas?.map((d, i) => (
                    <div key={d?._id || i} className='border rounded-md p-3 bg-white'>
                      <div className='flex items-start justify-between'>
                        <div>
                          <h6 className='text-[13px] font-[700]'>{d?.name}</h6>
                          <h6 className='text-[11px] text-slate-600'>{d?.mobile}</h6>
                        </div>
                        <div className='flex items-center -mr-1.5'>
                          <span className='p-2 cursor-pointer'><AiOutlineEdit size={17} onClick={() => navigator('edit', { state: d })} /></span>
                          <span className='p-2 cursor-pointer'><AiOutlineDelete size={17} onClick={() => {setselecteddata(d);setmodal(true)}} /></span>
                        </div>
                      </div>

                      {d?.mode_type && <h6 className={`${d?.mode_type === 'Online' ? 'bg-green-200' : 'bg-blue-200'} px-1.5 py-0.5 text-[10px] font-[800] w-max rounded mt-1`}>{d?.mode_type}</h6>}
                      {d?.fees_end_date && <h6 className='text-[10px] text-slate-500 mt-1'>Fees End Date : {moment(d?.fees_end_date)?.format('LL')}</h6>}
                      {d?.email && <h6 className='text-[11px] mt-1 break-all'>{d?.email}</h6>}

                      <h6 className='text-[11px] mt-2'><span className='font-[600]'>Standard:</span> {d?.classInfo || '-'}</h6>
                      <h6 className='text-[11px] mt-1'><span className='font-[600]'>Class Room:</span> {d?.class_room?.name} [{d?.class_room?.label}]</h6>

                      <div onClick={() => toggleActive(d)} className='flex items-center mt-2 cursor-pointer'>
                        {d?.is_active !== false ? <BiCheckboxSquare size={20} className='text-slate-800' /> : <BiCheckbox size={20} className='text-slate-300' />}
                        <h6 className='text-[11px] font-[600] ml-1'>Active</h6>
                      </div>

                      <h6 className='text-[10px] text-slate-400 mt-2'>Created {moment(d?.createdAt)?.format('LL')}</h6>
                    </div>
                  ))}
                </div>
                </>}
            </div>

          </div>

        </div>
      </div>
    </div>
  )
}

export default OfflineCustomerList